module.exports = __webpack_public_path__ + "img/detect.cbf19490.jpg";